"use strict";

require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _usePrefixCls = require("../_utils/hooks/usePrefixCls");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var Thumbnail = function Thumbnail(props) {
  var active = props.active,
    imageUrl = props.imageUrl,
    className = props.className,
    style = props.style,
    _props$onChoose = props.onChoose,
    onChoose = _props$onChoose === void 0 ? function () {} : _props$onChoose;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    isError = _useState2[0],
    setIsError = _useState2[1];
  (0, _react.useEffect)(function () {
    setIsError(false);
  }, [imageUrl]);
  var prefixCls = (0, _usePrefixCls.usePrefixCls)('thumbnail');
  var classes = (0, _classnames.default)(prefixCls, {
    'is-active': !!active
  }, className);
  var handleError = function handleError(e) {
    setIsError(true);
  };
  var handleLoad = function handleLoad(e) {
    setIsError(false);
  };
  var errorIcon = /*#__PURE__*/_react.default.createElement("svg", {
    width: "120",
    height: "120",
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    opacity: "0.01",
    x: "24",
    y: "24",
    width: "72",
    height: "72",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M30 84V36H90V84H30Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M39 55.5H81V58.5H39V55.5Z",
    fill: "#C1CCDD"
  }), /*#__PURE__*/_react.default.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M39 66H69V69H39V66Z",
    fill: "#C1CCDD"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "30",
    y: "36",
    width: "60",
    height: "10.5",
    fill: "#C1CCDD"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    opacity: "0.01",
    x: "72",
    y: "66",
    width: "30",
    height: "30",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "87",
    cy: "81",
    r: "10.5",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M87 69C80.373 69 75 74.373 75 81C75 87.627 80.373 93 87 93C93.627 93 99 87.627 99 81C99 74.373 93.627 69 87 69ZM88.5 87V84H85.5V87H88.5ZM88.5 75V82.5H85.5V75H88.5Z",
    fill: "#006EFF"
  }));
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes,
    style: style,
    onClick: function onClick() {
      console.log('imageUrl', imageUrl);
      onChoose();
    }
  }, !!imageUrl && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isError ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "-error")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "-error__img")
  }, errorIcon))) : /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__object")
  }, /*#__PURE__*/_react.default.createElement("img", {
    onLoad: handleLoad,
    className: "".concat(prefixCls, "__image"),
    src: imageUrl,
    onError: handleError
  }))));
};
Thumbnail.defaultProps = {};
var _default = exports.default = Thumbnail;